import React, {useEffect, useRef, useState} from "react";
import {useLocation, useNavigate} from "react-router-dom";
import axios from "axios";
import TourCardIndividual from "../../components/TourCard/TourCardIndividual";
import LoadingInside from "../../components/Loading/LoadingInside";

import s from "./Recommendations.module.scss";
import ComboOfferCard from "../ComboOffers/ComboCard/ComboOfferCard";

const apiUrl = process.env.REACT_APP_API_URL;

const Recommendations = () => {
    const navigate = useNavigate();
    const {state} = useLocation();

    const tourId = state?.tourId;
    const checkout = state?.checkout;

    const [loading, setLoading] = useState(true);
    const [comboOffers, setComboOffers] = useState([]);
    const [recommendations, setRecommendations] = useState([]);
    const scrollerRef = useRef(null);
    const [activeDot, setActiveDot] = useState(0);

    const [isDown, setIsDown] = useState(false);
    const [startX, setStartX] = useState(0);
    const [scrollLeft, setScrollLeft] = useState(0);

    useEffect(() => {

        if (!tourId) {
            navigate(
                checkout ? "/cart" : "/all-tours",
                {replace: true}
            );
            return;
        }

        const loadRecommendations = async () => {
            try {
                setLoading(true);

                const res = await axios.get(
                    `${apiUrl}/api/tours/${tourId}/combos?multi_city=false`
                );

                const combos = res.data.data || [];

                setComboOffers(combos);
                // Nothing to show
                if (combos.length === 0) {
                    navigate(
                        checkout ? "/cart" : "/all-tours",
                        {replace: true}
                    );
                }

            } catch (err) {
                console.error(err);

                navigate(
                    checkout ? "/cart" : "/all-tours",
                    {replace: true}
                );

            } finally {
                setLoading(false);
            }
        };

        loadRecommendations();

    }, [tourId, checkout, navigate]);

    const handleScroll = () => {
        const el = scrollerRef.current;

        if (!el) return;

        // Width of one visible page
        const pageWidth = el.clientWidth;

        const index = Math.round(el.scrollLeft / pageWidth);

        setActiveDot(index);
    };
    const onMouseDown = (e) => {
        const slider = scrollerRef.current;

        setIsDown(true);
        setStartX(e.pageX - slider.offsetLeft);
        setScrollLeft(slider.scrollLeft);
    };

    const onMouseLeave = () => {
        setIsDown(false);
    };

    const onMouseUp = () => {
        setIsDown(false);
    };

    const onMouseMove = (e) => {
        if (!isDown) return;

        e.preventDefault();

        const slider = scrollerRef.current;
        const x = e.pageX - slider.offsetLeft;
        const walk = (x - startX) * 1.5;

        slider.scrollLeft = scrollLeft - walk;
    };

    const formatPrice = (price) => {
        return new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'AUD',
            minimumFractionDigits: 2
        }).format(price);
    };
    if (loading) {
        return <LoadingInside height="50vh"/>;
    }

    return (
        <div className={s.page}>
<div className={'row mt-5'}>
    <div className={'col-12'}>
        <h2>よく一緒に購入されているツアー
        </h2>
    </div>
</div>


            {comboOffers.length > 0 && (
                <>

                    {comboOffers.map(combo => (
                        <ComboOfferCard
                            key={combo.id}
                            combo={combo}
                        />
                    ))}
                </>
            )}

            <div className={s.bottomBar}>

                <button
                    className={s.secondary}
                    onClick={() => navigate("/all-tours")}
                >
                    いいえ、別のツアーを予約します。
                </button>

                <button
                    className={s.primary}
                    onClick={() => navigate("/cart")}
                >
                    いいえ、そのままチェックアウトへ進みます。
                </button>

            </div>

        </div>
    );
};

export default Recommendations;